import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ISmartCanvasOptions, ISmartCanvasPolygon } from 'src/modules/shared/models/interfaces/smart-canvas.interface';
import { EventEmitterService } from 'src/modules/shared/services/event-emitter.service';
import { WordDataTypeEnum } from '../../../shared/models/enums/word-data-type.enum';
import { IFileLine, IFileProcessedWord, IFileWord } from '../../../shared/models/interfaces/files.interface';

@Component({
  selector: 'hcr-smart-canvas-tooltip',
  templateUrl: './smart-canvas-tooltip.component.html',
  styleUrls: ['./smart-canvas-tooltip.component.sass'],
})
export class SmartCanvasTooltipComponent {
  @Input() smartCanvasOptions: ISmartCanvasOptions;
  @Input() konvaStage: any; //Konva.Stage;
  @ViewChild('wordCanvasTooltip', { static: true }) wordCanvasTooltipElem: ElementRef;

  public wordDataTypeEnum = WordDataTypeEnum;
  public wordData: IFileWord | IFileLine = null;
  public show = false;
  public position = { x: 0, y: 0 };

  public get wordProcessedValues(): IFileProcessedWord[] | null {
    return this.wordData?.processedValues || [];
  }

  public get wordRoundedConfidence(): number {
    return Math.round(this.wordData?.confidence * 100);
  }

  constructor(private _eventEmitter: EventEmitterService) {
    this._eventEmitter.get<ISmartCanvasPolygon>('show-canvas-tooltip').subscribe((item) => {
      this.show = true;
      this.wordData = item.content;

      this.konvaStage.off('mousemove.tooltip').on('mousemove.tooltip', (opt) => {
        this.position = {
          x: <number>opt.evt.offsetX - <number>opt.target.getStage().content.offsetLeft,
          y: <number>opt.evt.offsetY - <number>opt.target.getStage().content.offsetTop,
        };
      });
    });

    this._eventEmitter.get<ISmartCanvasPolygon>('hide-canvas-tooltip').subscribe(() => {
      this.show = false;
      this.konvaStage.off('mousemove.tooltip');
    });
  }
}
